import { gql } from '@apollo/client';
import { query } from '../../../../Services/Gateway/Apollo';

export const GET_MATCHING_SUPPLIERS = gql`
  query GetMatchingSuppliers(
    $subcategoryId: String!
    $answers: [AnswerInput!]!
    $questionsOnForm: [String!]
    $countUp: Boolean
  ) {
    getMatchingSuppliers(
      subcategoryId: $subcategoryId
      answers: $answers
      questionsOnForm: $questionsOnForm
      countUp: $countUp
    ) {
      matchingSupplierCount
    }
  }
`;

const getMatchingSuppliersQuery = async (params) => {
  const { variables } = params;
  const response = await query({
    query: GET_MATCHING_SUPPLIERS,
    variables,
  });

  return response.data.getMatchingSuppliers;
};

export default getMatchingSuppliersQuery;
